import React from 'react';

export const WelcomeBanner: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h1 className="text-2xl font-bold mb-2">👋 Welcome</h1>
    </div>
  );
};